export default "__VITE_ASSET__1SI4eeXa__"